import React from 'react';
import { Link } from 'react-router-dom';
import { Music, Church, Heart, Star, ArrowRight, Instagram } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { companyInfo, testimonials } from '../data/mock';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-24 md:pt-32 pb-16 md:pb-20 px-4 bg-gradient-to-br from-[#DFD6CD] via-[#FAF9F7] to-[#DFD6CD]">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-4 md:mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-white/60 backdrop-blur-sm rounded-full text-xs md:text-sm font-medium text-[#920216] border border-[#CDAD1E]/30">
                <Church size={14} className="text-[#B30310] md:w-4 md:h-4" />
                Especialistas em Casamentos Católicos
              </span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#920216] mb-4 md:mb-6 leading-tight px-2" style={{ fontFamily: "'Belleza', serif" }}>
              A trilha sonora perfeita
              <span className="block text-[#B30310]">para o seu "sim"</span>
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-gray-700 mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto px-4">
              Transformamos sua cerimônia católica em um momento inesquecível com música de qualidade, reverência e emoção.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center px-4">
              <Button
                asChild
                size="lg"
                className="bg-[#B30310] hover:bg-[#920216] text-white text-base md:text-lg px-6 md:px-8 py-5 md:py-6 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <Link to="/contato" className="flex items-center justify-center gap-2">
                  Fale Conosco <ArrowRight size={18} className="md:w-5 md:h-5" />
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-[#920216] text-[#920216] hover:bg-[#920216] hover:text-white text-base md:text-lg px-6 md:px-8 py-5 md:py-6 transition-all duration-300"
              >
                <Link to="/musicas">Ver Repertório</Link>
              </Button>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-[#CDAD1E]/10 rounded-full blur-xl"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-[#B30310]/10 rounded-full blur-xl"></div>
      </section>

      {/* About Section */}
      <section className="py-12 md:py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#920216] mb-4 md:mb-6 px-2">
              Especialistas em Cerimônias Católicas
            </h2>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed px-2">
              {companyInfo.description}
            </p>
          </div>

          <div className="flex justify-center">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <Card className="border-[#CDAD1E]/30 hover:shadow-lg transition-shadow duration-300">
              <CardContent className="pt-6 md:pt-8 text-center px-4">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-[#DFD6CD] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <Music className="text-[#B30310]" size={28} />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-[#920216] mb-2 md:mb-3">Repertório Litúrgico</h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Seleção cuidadosa de músicas apropriadas para cada momento da cerimônia católica.
                </p>
              </CardContent>
            </Card>

            <Card className="border-[#CDAD1E]/30 hover:shadow-lg transition-shadow duration-300">
              <CardContent className="pt-6 md:pt-8 text-center px-4">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-[#DFD6CD] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <Heart className="text-[#B30310]" size={28} />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-[#920216] mb-2 md:mb-3">Sensibilidade Musical</h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Execução impecável que emociona e eleva o momento mais especial da sua vida.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

          {/* Pricing Highlight */}
          <div className="mt-12 md:mt-16">
            <Card className="border-2 border-[#CDAD1E] bg-gradient-to-br from-[#DFD6CD]/30 to-white shadow-lg">
              <CardContent className="p-6 md:p-8 text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#CDAD1E] rounded-full mb-3 md:mb-4">
                  <span className="text-2xl md:text-3xl font-bold text-white">%</span>
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#920216] mb-2 md:mb-3 px-2">
                  Preços Justos e Acessíveis
                </h3>
                <p className="text-sm md:text-base lg:text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto px-2">
                  Oferecemos serviços de alta qualidade com valores abaixo do mercado, porque acreditamos que 
                  todo casal merece ter música profissional e emocionante em sua cerimônia. Nosso compromisso é 
                  tornar o seu sonho realidade sem comprometer o orçamento do casamento.
                </p>
                <div className="mt-4 md:mt-6 px-2">
                  <Button
                    asChild
                    size="lg"
                    className="bg-[#B30310] hover:bg-[#920216] text-white transition-all duration-300 text-sm md:text-base w-full sm:w-auto"
                  >
                    <Link to="/contato" className="whitespace-normal text-center">
                      Solicite um Orçamento
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 bg-[#DFD6CD]/30">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#920216] mb-4">
              Conheça Nossa Equipe
            </h2>
            <p className="text-lg text-gray-700 mb-12">
              Músicos profissionais dedicados a tornar seu casamento inesquecível
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto mb-20">
            {/* Ana Júlia */}
            <Card className="bg-white border-[#CDAD1E]/30 hover:shadow-xl transition-all duration-300 overflow-hidden">
              <CardContent className="p-0">
                <div className="relative aspect-[3/4] overflow-hidden bg-[#DFD6CD]">
                  <img 
                    src="/images/ana-julia.jpg" 
                    alt="Ana Júlia - Harmonia Nupcial"
                    className="w-full h-full object-cover object-top team-photo"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-2xl font-bold text-[#920216] mb-2">Ana Júlia</h3>
                  <p className="text-[#CDAD1E] font-semibold mb-3">Voz e Música Sacra</p>
                  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                    Cantora e cofundadora do Harmonia Nupcial, Ana Júlia é especialista em repertório litúrgico católico. 
                    Sua voz une técnica, delicadeza e profunda sensibilidade espiritual, conduzindo cada cerimônia com emoção, reverência e significado.
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Douglas */}
            <Card className="bg-white border-[#CDAD1E]/30 hover:shadow-xl transition-all duration-300 overflow-hidden">
              <CardContent className="p-0">
                <div className="relative aspect-[3/4] overflow-hidden bg-[#DFD6CD]">
                  <img 
                    src="/images/douglas.jpg" 
                    alt="Douglas - Harmonia Nupcial"
                    className="w-full h-full object-cover object-top team-photo"
                    loading="lazy"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-2xl font-bold text-[#920216] mb-2">Douglas</h3>
                  <p className="text-[#CDAD1E] font-semibold mb-3">Multi-instrumentista e Arranjos</p>
                  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                    Multi-instrumentista e cofundador do Harmonia Nupcial, Douglas é responsável pelos arranjos e pela 
                    construção musical de cada celebração. Com ampla experiência em cerimônias católicas, seu trabalho respeita a liturgia e valoriza cada momento com harmonia, equilíbrio e excelência musical.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#920216] mb-4">
              Depoimentos de Casais
            </h2>
            <p className="text-lg text-gray-700">
              A opinião de quem viveu esse momento especial conosco
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="bg-white border-none shadow-md hover:shadow-xl transition-shadow duration-300">
                <CardContent className="pt-6">
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={18} className="fill-[#CDAD1E] text-[#CDAD1E]" />
                    ))}
                  </div>
                  <p className="text-gray-700 mb-4 italic leading-relaxed">
                    "{testimonial.text}"
                  </p>
                  <div className="border-t border-gray-200 pt-4">
                    <p className="font-semibold text-[#920216]">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">{testimonial.date}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-[#920216] to-[#B30310] text-white">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Vamos Tornar Seu Casamento Inesquecível?
          </h2>
          <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Entre em contato conosco e descubra como podemos criar a trilha sonora perfeita para o seu grande dia.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-white text-[#920216] hover:bg-[#DFD6CD] text-lg px-8 py-6 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Link to="/contato" className="flex items-center gap-2">
                Solicite um Orçamento <ArrowRight size={20} />
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-white text-white hover:bg-white hover:text-[#920216] text-lg px-8 py-6 transition-all duration-300"
            >
              <a 
                href="https://www.instagram.com/harmonianupcialbsb/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2"
              >
                <Instagram size={20} /> Siga no Instagram
              </a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;